__webpack_require__.p = "/token-translator/";